import { px, percent, padding, rem, important } from "csx";
import { stylesheet } from "typestyle";
import { Colours, fontFamily, Sizes } from "../../styles";

export const inputStyles = stylesheet({
  container: {
    boxSizing: "border-box",
    padding: padding(0, rem(0.5)),
    backgroundColor: Colours.darkBlue,
    border: `1px solid ${Colours.blue}`,
    borderRadius: px(5),
    borderBottomWidth: px(1),
    minHeight: px(36),
    $nest: {
      "&.disabled": {
        cursor: "default",
        border: "none",
      },
    },
  },
  input: {
    height: px(34),
    width: percent(100),
    boxSizing: "border-box",
    color: Colours.textLight,
    background: "transparent",
    border: "none",
    fontSize: Sizes.fontSize2,
    caretColor: Colours.textLight,
    fontFamily,
    $nest: {
      "&:focus": {
        outline: "none",
      },
      "&:disabled": {
        color: Colours.textDisabled,
      },
      "&.readonly": {
        color: Colours.textLight,
      },
      "&:-webkit-autofill, textarea:-webkit-autofill": {
        "-webkit-box-shadow": `0 0 0 1000px ${Colours.darkBlue} inset !important`,
        "-webkit-text-fill-color": important("white"),
      },
      "&::-webkit-calendar-picker-indicator": {
        filter: "invert(1)",
        opacity: 0.5,
        cursor: "pointer",
      },
      "&::-webkit-outer-spin-button, &::-webkit-inner-spin-button": {
        "-webkit-appearance": "none",
        margin: 0,
      },
      "&[type=number]": {
        "-moz-appearance": "textfield",
      },
    },
  },
  suffix: {
    fontFamily,
    fontSize: Sizes.fontSize2,
    color: Colours.textLight,
    pointerEvents: "none",
    textAlign: "right",
    $nest: {
      "&.disabled": {
        color: Colours.textDisabled,
      },
    },
  },
});
